import { lt } from '@mews/framework';
import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { useCityLedgerMultipleInvoicesContext } from '../../../../context/CityLedgerMultipleInvoicesContext';
import { DEFAULT_ALLOWED_TYPES } from '../../../SendReminder/constants';
import { useSendReminderDialog } from '../../../SendReminder';

interface SendReminderButtonProps {
    accountId: string;
    invoiceId: string;
    isSendReminderButtonDisabled: boolean;
}

export const SendReminderButton = ({ accountId, isSendReminderButtonDisabled }: SendReminderButtonProps) => {
    const { ownerEmails, setSelectedInvoices, selectedInvoices } = useCityLedgerMultipleInvoicesContext();
    const [renderSendReminderDialog, toggleDialog] = useSendReminderDialog({
        accountId,
        invoices: selectedInvoices,
        allowedInvoiceTemplateTypes: DEFAULT_ALLOWED_TYPES,
        onFormSuccess: () => setSelectedInvoices([]),
        ownerEmails,
    });

    return (
        <>
            <ActionToolbarButton
                data-test-id="send-reminder-action"
                icon={IconName.SendMessage}
                onClick={toggleDialog}
                disabled={isSendReminderButtonDisabled}
                actionToolbarEnabled
            >
                {lt('SendReminder')}
            </ActionToolbarButton>
            {renderSendReminderDialog()}
        </>
    );
};
